import { Component } from '@angular/core';

@Component({
  selector: 'wk8-pipe-back',
  imports: [],
  templateUrl: './wk8-pipe-back.component.html',
  styleUrl: './wk8-pipe-back.component.css',
})
export class Wk8PipeBackComponent {}
